var _path, _polyline;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCcassPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ccass_plus") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.18,14s-5.14-.16-9,0c-6,.23-9.12,3.11-12.65,6.85s-5.42,6.7-5.42,11.75c0,2.77.29,5.53,1.78,7.52s4.29,3.81,8.47,5.5A66.81,66.81,0,0,0,38,49.41c2.1.3,4.24.55,6.44.73s4.6.33,7.22.43,5.07.15,7.35.15l-5.32,7.05A119.7,119.7,0,0,1,31.48,60q-13.82,0-20.19-5.34C7,51.12,4,46.07,4,40.41c0-6.26,1-13.52,4.52-19.58S12.08,15,20.21,9.08c3.63-2.1,3.61-2,9-3.92A33.12,33.12,0,0,1,41,4.18c-2.71,5.88-1.8,9.8-1.8,9.8"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "44.04 4.9 44.04 16.21 34.66 19.42 34.66 24.82 44.42 23.92 44.42 34.71 50.11 34.71 50.11 23.92 59.05 22.12 59.05 14.92 50.11 16.72 50.11 5.93 44.04 4.9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCcassPlus);
export default __webpack_public_path__ + "static/media/ccass_plus.8af40b14de075aac3f08385e1db1bc90.svg";
export { ForwardRef as ReactComponent };